import { useEffect, useState } from "react";
import {
  getSharePresales,
  setSharePresales,
  subscribeSharePresales,
} from "../lib/sharePresalesStore";

export function useSharePresales() {
  const [sharePresales, setLocalSharePresales] = useState(getSharePresales());

  useEffect(() => {
    setLocalSharePresales(getSharePresales());
    return subscribeSharePresales(() => {
      setLocalSharePresales(getSharePresales());
    });
  }, []);

  return {
    sharePresales,
    setSharePresales,
  };
}
